
import { group } from '@angular/animations';
import { ChangeDetectorRef, Component, ElementRef, OnInit, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { PageBase, UIService, RentalObjectStatus, DamageInfo } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';


@Pipe({ name: 'enumStatus' })
export class EnumStatusPipe implements PipeTransform {
  transform(value: number): string {
    return RentalObjectStatus[value];
  }
}

@Component({
  styleUrls: ['./SecurityCheckDashboard.css'],
  selector: 'SecurityCheckDashboard',
  templateUrl: './SecurityCheckDashboard.component.html',
})

export class SecurityCheckDashboardComponent extends PageBase implements OnInit {

  @ViewChild("securityCheckTable")
  private securityCheckTable: T4DatatableWidget;
  constructor(el: ElementRef,
    private route: ActivatedRoute,
    private ui: UIService,
    private changeDetectorRef: ChangeDetectorRef) {
      super(el, "SecurityCheckDashboard");
    }

  public loading: boolean = false;

  public activeSecurityChecks: DamageInfo[];
  public filteredSecurityChecks: DamageInfo[];
  public filterGroups = new Set<string>();
  public filterGroupList = [];
  groupsControl = new FormControl([]);
  public amountSelected: number;
  public removingProcessing: boolean;

  async ngOnInit() {
    this.loading = true;
    this.activeSecurityChecks = await this.Api.get<any[]>("RentalObject/GetAllActiveSecurityChecks")

    await this.createFilterOptions();

    this.loading = false;
    
  }
  

  public async createFilterOptions() {
    this.activeSecurityChecks.forEach(x => this.filterGroups.add(x.RentalLocationGroupName));
    this.applyFilter();
  }

  applyFilter() {
    const selectedGroups = this.groupsControl.value;// Get the selected values from the FormControl
    this.filteredSecurityChecks = this.filterData(selectedGroups);

    this.changeDetectorRef.detectChanges(); 
  }

  filterData(selectedGroups: string[]): DamageInfo[] {
    if (selectedGroups.length === 0) return this.activeSecurityChecks.filter(item => (!item.HandledSG && !item.HandledCS))
    return this.activeSecurityChecks.filter(item => selectedGroups.some(group => group === item.RentalLocationGroupName) && (!item.HandledSG && !item.HandledCS));
  }

  public async openSecurityCheckInfoDialog(data: any) {

    const dialogConfigSettings = new MatDialogConfig();
    dialogConfigSettings.minWidth = '600px';
    dialogConfigSettings.minHeight = '400px';

    dialogConfigSettings.data = data;

    await this.ui.openDialog("T4.Service.SecurityCheckInfoDialog", dialogConfigSettings);   
  }

  public selectAll() {
    this.securityCheckTable.data.data.forEach(x => {
      x.Checked = true;
    }
    )
    this.securityCheckTable.update();
  }


  public deselectAll() {
    this.securityCheckTable.data.data.forEach(x => {
      if (x.Checked == true) x.Checked = false;
    })
    this.securityCheckTable.update();
  }

  public async deleteSelected() {
    if (this.securityCheckTable.selectedRows.length <= 0) return;

    var x = await this.UI.confirm("Turbo.SecurityCheckDashboard.headConfirmRemoval", "Are you sure?", "Turbo.SecurityCheckDashboard.msgConfirmRemoval", 'Are you sure that you want to remove {0} security checks?', null, [this.securityCheckTable.selectedRows.length]);
    this.amountSelected = this.securityCheckTable.selectedRows.length ?? 0;
    this.removingProcessing = true;
    if (x) {
      for (const row of this.securityCheckTable.selectedRows) {
        const result = await this.markSecurityCheckAsComplete(row.TrailerId);
        this.amountSelected--;
        if (result) {
          row.HandledCS = true;
          row.HandledSG = true;
        }
      }
    }
    //Update the list and removes the deleted ones directly.
    this.filteredSecurityChecks = this.filteredSecurityChecks.filter(x => !x.HandledCS && !x.HandledSG);
    this.securityCheckTable.update();
    this.removingProcessing = false;
  }

  public async markSecurityCheckAsComplete(trailerId: number) {
    let result = await this.Api.post<boolean>("Service/RegisterHandledComplete", null, { rentalObjectId: trailerId })
    let result2 = await this.Api.get<boolean>("RentalObject/SetAllCsSecurityResult", { type: 1, rentalObjectId: trailerId, input: 5 });
  
    if (result) {
      return true;
    }
    return false;
  }
}

